import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, PopupHeader, RowsContainer, Select } from '@streamr/tv-ui';
import { useId, useState } from 'react';
import styled from 'styled-components';
import { ELIGIBLE_COUNTRIES_FOR_MERCHANTS } from '../../../consts';
import { PurchaseService } from '../../../services/purchase/PurchaseService';
import { Popup, TopCenter } from '../../../utils/popups';
import { AbstractPopup, DismissalReason, } from '../AbstractPopup';
import { PopupCssPreset } from '../Popup.styles';
import { showTermsOfServicePopup } from '../TermsOfServicePopup';
const MerchantOnboardingPopup = ({ reject, resolve, ...props }) => {
    const [country, setCountry] = useState('');
    const inputId = useId();
    return (_jsx(MerchantOnboardingPopupRoot, { reject: reject, translateFn: TopCenter, ...props, children: _jsxs(RowsContainer, { children: [_jsx(PopupHeader, { onCloseButtonClick: () => {
                        reject(DismissalReason.CloseButton);
                    }, children: _jsx(Title, { children: "Register as a merchant" }) }), _jsx(Subtitle, { children: "Start earning from StreamrTV content with a Stripe connected account." }), _jsxs(Select, { defaultValue: country, onChange: (e) => {
                        setCountry(e.target.value);
                    }, id: inputId, children: [_jsx("option", { value: "", disabled: true, children: "Choose a country" }), ELIGIBLE_COUNTRIES_FOR_MERCHANTS.map((country) => (_jsx("option", { value: country.code, children: country.name }, country.code)))] }), _jsx(ContinueButtonContainer, { children: _jsx(ContinueButton, { disabled: !country, onClick: async () => {
                            resolve();
                            await showTermsOfServicePopup({
                                anchorRef: props.anchorRef,
                                mode: 'acceptance',
                                onResolve: async (accepted) => {
                                    if (accepted) {
                                        try {
                                            await PurchaseService.getInstance().navigateToStripeOnboardingPage(country);
                                        }
                                        catch {
                                            // TODO better error handling: e.g. show a toast in the UI?
                                            console.error('Unable to navigate to Stripe onboarding page');
                                        }
                                    }
                                    return true;
                                },
                            });
                        }, children: "Continue" }) })] }) }));
};
const MerchantOnboardingPopupRoot = styled(AbstractPopup) `
    ${PopupCssPreset.Center};
    --Popup_Padding: 1.5rem;
    --Popup_Width: 90vw;

    @media (min-width: 60rem) {
        --Popup_Width: 50rem;
    }
`;
const ContinueButtonContainer = styled.div `
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.5rem 0;
`;
const ContinueButton = styled(Button) `
    --Button_Background: var(--tv-ui-color-3);
    --Button_TextColor: var(--tv-ui-color-4);
    --Button_TextSize: 1.125rem;
    --Button_HoverBackground: var(--tv-ui-color-3);
    --Button_BorderRadius: 1rem;
    --Button_Padding: 1rem 2rem;
    --Button_HoverTransform: scale(1.02);
    --Button_ActiveTransform: scale(1.02);
`;
const Title = styled.h2 `
    font-size: 1.4rem;
    font-weight: 500;
    text-align: center;
`;
const Subtitle = styled.p `
    font-size: 1.125rem;
    font-weight: 400;
    text-align: center;
`;
const merchantOnboardingPopup = Popup.create(MerchantOnboardingPopup);
export function showMerchantOnboardingPopup(options) {
    (async () => {
        try {
            options.onOpenPopup?.();
            await merchantOnboardingPopup.pop({
                anchorRef: options.anchorRef,
            });
        }
        catch (_ignore) {
        }
        finally {
            options.onClosePopup?.();
        }
    })();
}
